module.exports = __webpack_public_path__ + "img/userConfirmation-b.d1a10839.svg";